import VideoJsAdapter from "../../adapters/videojs_adapter";
import Component from '../component';
import Button from "../button";
import SubtitleList from "./subtitle_list";

export default class Index extends Button {
  constructor(player, options = {}) {
    super(player, options);
    this.player = player;
    this.subtitleList = new SubtitleList(this.player, options);
    this.el().appendChild(this.subtitleList.el());
    this.count = 0;
  }

  createEl() {
    var props = {
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass()
    };

    var el = Component.prototype.createEl.call(this, 'button', props);
    this.createControlTextEl(el);
    return el;
  }

  buildCSSClass() {
    var additionClass = this.options_.show ? '' : ' vjs-hidden';
    return 'vjs-subtitle-switcher vjs-control' + additionClass;
  }

  handleClick() {
    if (this.count == 0) {
      this.subtitleList.setEl();
    }
    this.subtitleList.toggle();
    this.count++;
  }
}

Index.prototype.controlText_ = "Subtitle";
VideoJsAdapter.registerComponent('VpSubtitle', Index);
